import { render, staticRenderFns } from "./FormServer.vue?vue&type=template&id=438800be&"
import script from "./FormServer.vue?vue&type=script&lang=js&"
export * from "./FormServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports